// extracted by mini-css-extract-plugin
export default {"item":"PreoperativeTestsRepeaterItem_item__aJgrO"};